/**
 * Публичный origin сайта (canonical, OG, sitemap, robots).
 * Не использовать localhost в production-фолбэке.
 */
export function getAppUrl(): string {
  const raw =
    process.env.SITE_URL?.trim() ||
    process.env.NEXT_PUBLIC_SITE_URL?.trim() ||
    process.env.NEXTAUTH_URL?.trim() ||
    process.env.APP_URL?.trim() ||
    "";

  if (raw) return raw.replace(/\/$/, "");

  const appEnv =
    process.env.NEXT_PUBLIC_APP_ENV ?? process.env.APP_ENV ?? process.env.NODE_ENV;

  if (appEnv === "production") return "https://idealitika.ru";
  if (appEnv === "development") return "https://dev.idealitika.ru";

  return "http://localhost:3000";
}
